// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3sB0e","header":"ClearentDisclaimer_header__1FZbu","inner":"ClearentDisclaimer_inner__16WX9"};